import React from "react";
import { useMediaQuery } from "react-responsive";
import { Tooltip } from "../screens/customize/Tooltip";

function Stepper({ currentStep, steps, onStepClick }) {
	const isMobile = useMediaQuery({ maxWidth: 767 });

	return isMobile ? (
		<div className="flex justify-between w-full mt-4">
			{steps.map((step) => {
				const isActive = step.page === currentStep;
				const isCompleted = step.page < currentStep;

				return (
					<div
						key={step.page}
						id={step.page}
						className={`flex text-[12px] cursor-pointer ${
							isActive
								? "text-red-700 font-bold"
								: isCompleted
								? "text-black"
								: "text-gray-500"
						}`}
						onClick={() => onStepClick(step)}
					>
						{step.name}
						{step.name !== "Summary" && <div className="px-1">|</div>}
					</div>
				);
			})}
		</div>
	) : (
		<div className="flex justify-between w-full relative">
			{steps.map((step, index) => {
				const isActive = step.page === currentStep;
				const isCompleted = step.page < currentStep;

				return (
					<div
						key={step.page}
						id={step.page}
						className={`flex flex-col items-center flex-1 relative cursor-pointer ${
							isActive
								? "font-bold"
								: isCompleted
								? "text-red-700"
								: "text-gray-500"
						}`}
						onClick={() => onStepClick(step)}
					>
						{/* Step Counter */}
						<div
							className={`z-10 flex justify-center items-center w-10 h-10 rounded-full mb-2 ${
								isCompleted ? "bg-red-700 text-white" : "bg-gray-300"
							}`}
						>
							{step.page}
						</div>

						{/* Step Name */}
						<div className="text-center">
							<span>{step.name}</span>
							<Tooltip content={step.info} title={step.name}>
								<span className="ml-2 text-gray-400 border border-gray-400 rounded-full px-1">
									i
								</span>
							</Tooltip>
						</div>

						{/* Line Before */}
						{index !== 0 && (
							<div
								className="z-1 absolute top-5 left-0 w-1/2 border-t-2"
								style={{ borderColor: isCompleted ? "#d32f2f" : "#ccc" }}
							></div>
						)}

						{/* Line After */}
						{index !== steps.length - 1 && (
							<div
								className="z-1 absolute top-5 right-0 w-1/2 border-t-2"
								style={{ borderColor: isCompleted ? "#d32f2f" : "#ccc" }}
							></div>
						)}
					</div>
				);
			})}
		</div>
	);
}

export default Stepper;
